import { apiClass } from '@/base/class/api.class'
import { ENDPOINTS } from '@/base/const/endpoints.const'

const state = {
  loading: false,
  data: null,
  error: {
    invalidFields: null,
  },
}

const mutations = {
  SET_CONFIRMATION_LOADING(state, value) {
    state.loading = value
  },
  SET_CONFIRMATION_DATA(state, data) {
    state.data = data
  },
  SET_CONFIRMATION_ERROR_INVALID_FIELDS(state, data) {
    state.error.invalidFields = data
  },
}

const actions = {
  getConfirmationTrx({ commit, state, dispatch }, { hash, orderId, serviceId }) {
    commit('SET_CONFIRMATION_LOADING', true)
    const data = {
      hash,
      orderId,
      serviceId,
    }
    return apiClass
      .post(ENDPOINTS.confirmation, data)
      .then((response) => {
        const data = response.body.data
        commit('SET_CONFIRMATION_DATA', data)
        dispatch('setPaymentLanguage', data)
        return Promise.resolve(response)
      })
      .finally(() => {
        commit('SET_CONFIRMATION_LOADING', false)
      })
      .catch((error) => {
        if (error.body?.invalidFields) {
          commit('SET_CONFIRMATION_ERROR_INVALID_FIELDS', error.body.invalidFields)
        }
        return Promise.reject(error)
      })
  },
  /**
   * Odczyt danych transakcji z `/confirmation` BEZ efektów ubocznych widoku potwierdzenia:
   * nie rusza `SET_CONFIRMATION_LOADING` (żaden loader nie mignie) i nie dispatchuje
   * `setPaymentLanguage` (język użytkownika zostaje taki, jaki wybrał).
   *
   * Trzech konsumentów:
   *   - czekajka Visa Mobile (`VisaMobileProcess/Data.vue`) - pyta o STAN transakcji w pętli;
   *   - powrót z zewnętrznego 3DS w trybie kartowym (`views/CardBack.vue`) - odtwarza DANE
   *     transakcji dla panelu zamówienia, bo po powrocie z ACS magazyn Vuex jest pusty;
   *   - sam ekran potwierdzenia (`views/Confirmation.vue`) przy `PENDING` - ponowne odpytanie w tle,
   *     gdy powrót z banku wyprzedził ITN (PEP-1380); bez loadera ekran nie mignie.
   *
   * ⚠️ Wypełnienie `confirmation.data` przestawia `useOrderDetails` na źródło potwierdzenia
   * (`apiData` daje mu pierwszeństwo nad `payment.paymentData`) - o to właśnie chodzi, ale znaczy
   * to również, że prowizja liczy się wtedy z `confirmationData.transaction.customerFee`.
   *
   * @param {object} context
   * @param {{hash: string, orderId: string, serviceId: string}} params
   * @returns {Promise}
   */
  getConfirmationTrxSilent({ commit, state, dispatch }, { hash, orderId, serviceId }) {
    const data = {
      hash,
      orderId,
      serviceId,
    }
    return apiClass
      .post(ENDPOINTS.confirmation, data)
      .then((response) => {
        const data = response.body.data
        commit('SET_CONFIRMATION_DATA', data)
        return Promise.resolve(response)
      })
      .catch((error) => {
        if (error.body?.invalidFields) {
          commit('SET_CONFIRMATION_ERROR_INVALID_FIELDS', error.body.invalidFields)
        }
        return Promise.reject(error)
      })
  },
}

const getters = {}

export default {
  state,
  mutations,
  actions,
  getters,
}
